import { useEffect } from "react";
import { LandingPageView } from "@/components/landing/LandingPageView";
import { useLandingSettings } from "@/hooks/useLandingPage";

const Landing = () => {
  const { data: settings } = useLandingSettings();

  useEffect(() => {
    if (settings?.seo_title) document.title = settings.seo_title;
    if (settings?.seo_description) {
      const meta = document.querySelector('meta[name="description"]');
      if (meta) meta.setAttribute("content", settings.seo_description);
    }
  }, [settings?.seo_title, settings?.seo_description]);

  return <LandingPageView />;
};

export default Landing;
